import Lenis from "lenis";

export function initLenis() {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf = requestAnimationFrame(function loop(t) {
        lenis.raf(t);
        raf = requestAnimationFrame(loop);
    });
    return () => {
        cancelAnimationFrame(raf);
        lenis.destroy();
        window.__lenis = null;
    };
}

export function scrollToSection(selector) {
    const el = document.querySelector(selector);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
    else el.scrollIntoView({ behavior: "smooth" });
}
